import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import DocLinkDash from "./pages/DocLinkDash";
import DocLinkAnalyticsPage from "./pages/DocLinkAnalyticsPage";
import QudaDash from "./pages/QudaDash";
import QudaAnalyticsPage from "./pages/QudaAnalyticsPage";
import ChemistAnalytics from "./pages/ChemistAnalytics";
// import ChemistData from "./pages/ChemistData";
import Overview from "./pages/Overview";
import Subscriptions from "./pages/Subscriptions";
import ResetPassword from "./pages/ResetPassword";
import validateToken from "./services/authService";
import Loading from "./components/Loading";
import Layout from "./components/Layout";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkToken = async () => {
      console.log("=== Authentication Check ===");
      console.log("LocalStorage contents:", Object.keys(localStorage));
      console.log("jwtToken exists:", !!localStorage.getItem('jwtToken'));
      console.log("googleUserInfo exists:", !!localStorage.getItem('googleUserInfo'));
      console.log("userData exists:", !!localStorage.getItem('userData'));
      
      const isValid = await validateToken();
      console.log("Token validation result:", isValid);
      setIsAuthenticated(isValid);
    };

    checkToken();
  }, []);

  if (isAuthenticated === null) {
    return <Loading />;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/overview" />
            ) : (
              <Login setIsAuthenticated={setIsAuthenticated} />
            )
          }
        />
        <Route
          path="/overview"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <Overview />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/quda"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <QudaDash setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/doclink"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <DocLinkDash setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/subs"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <Subscriptions setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/doclink-analytics/:chemistID"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <DocLinkAnalyticsPage setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/quda-analytics/:chemistID"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <QudaAnalyticsPage setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/chemist/:chemistID"
          element={
            isAuthenticated ? (
              <Layout setIsAuthenticated={setIsAuthenticated}>
                <ChemistAnalytics setIsAuthenticated={setIsAuthenticated} />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* <Route path="/loading" element={<Loading />} />  */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
